import {
    STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getLocationsDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                locationOptions: [],
                locationOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getLocationsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                locationOptions: action.data,
                locationOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getLocationsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                locationOptions: [],
                locationOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  